export enum GENDER {
    MALE = 'male',
    FEMALE = 'female',
    NON_BINARY = 'non-binary',
}

export enum AGE {
    YOUNG = 'young',
    ADULT = 'adult',
    OLDER = 'older',
}

export enum USE_CASE {
    AUDIOBOOK = 'audiobook',
    ASMR = 'ASMR',
    ANIMATION = 'animation',
    CONVERSATIONAL = 'conversational',
    CHILDRENS_STORIES = `children's stories`,
    DOCUMENTARY = 'documentary',
    INTERACTIVE = 'interactive',
    MEDITATION = 'meditation',
    NARRATION = 'narration',
    NEWS = 'news',
    VIDEO_GAMES = 'video games',
    NEWS_PRESENTER = 'news presenter',
}

export enum TIER {
    STANDARD = 'standard',
    PREMIUM = 'premium',
}

export enum FUNCTION {
    SPEED = 'speed',
    STYLE = 'style',
}
